import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';

import { useAssets } from '@labradorsports/assets';
import { ImageResize } from '@labradorsports/components';

import { Selectors, useUploadProfileImageMutation } from '../../store/index.js';

interface Props {
    readOnly?: boolean;
    profileImageUrl?: string;
}

const ProfileImageEditor: FC<Props> = ({ readOnly, profileImageUrl }) => {
    const uid = useSelector(Selectors.uid);
    const [uploadProfileImage] = useUploadProfileImageMutation();
    const [profileImage, setProfileImage] = useState(null);
    const imageResultRef = useRef(null);
    const { CoachIcon } = useAssets();

    const startProfileResize = (event: any) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.type.includes('image/')) {
                setProfileImage(event.target.files[0]);
                 
                event.target.value = '';
            }
        }
    };

    const cancelProfileResize = () => {
        setProfileImage(null);
    };

    const completeProfileResize = async () => {
        const result = await imageResultRef.current();

        uploadProfileImage({
            uid,
            file: result,
        });
        cancelProfileResize();
    };

    if (profileImage) {
        return (
            <div className="profile-image-editor">
                <ImageResize
                    width={150}
                    height={150}
                    imageWidth={150}
                    imageHeight={150}
                    file={profileImage}
                    resultRef={imageResultRef}
                    scaleResult
                />
                <Button color="primary" onClick={cancelProfileResize}>
                    Cancel
                </Button>
                <Button color="primary" onClick={completeProfileResize}>
                    Save
                </Button>
            </div>
        );
    }

    const uploadId = 'profile_image_upload';
    const uploadLink = (
        <div>
            <label className="profile-upload-link mb-0" htmlFor={uploadId}>
                Add Profile Picture
                <input type="file" id={uploadId} onChange={startProfileResize} accept="image/*" />
            </label>
        </div>
    );

    return (
        <div className="profile-image-editor">
            <div className="profile-pic">
                <img src={profileImageUrl ?? CoachIcon} alt="Profile" />
                {!readOnly ? uploadLink : undefined}
            </div>
        </div>
    );
};

export default ProfileImageEditor;
